import { Grid, Skeleton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FinanceType } from '../../../services/dtos/finances.dto';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { showAxiosMessageError } from '../../../utils/error-message.util';
import { RelationIndicatorsBillsDto, RelationType } from '../../../services/dtos/relation.dto';
import { getRelationBillsIndicators } from '../../../services/relation.service';
import { HeadCellDto } from '../../../services/dtos/head-cell.dto';
import NoData from '../../commun/no-data';
import StyledTable from '../../commun/table';
import { ResultSearchDto } from '../../../services/dtos/result-search.dto';

/**
 * Ui pour la page d'assemblée générale
 * @constructor
 */
export default function BillsRelationUi(
    props: Readonly<{
        mandate?: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
        type: FinanceType | RelationType;
        handlerSetType: (newFinance: FinanceType | RelationType | undefined, text: string | undefined) => void;
    }>
) {
    // Document du meeting à voir et télécharger
    const [billsIndicators, setBillsIndicators] = useState<ResultSearchDto<RelationIndicatorsBillsDto>>();
    // Page affichée deuxieme tableau
    const [page, setPage] = useState(0);
    // items par page deuxieme tableau
    const [itemsPerPage, setItemsPerPage] = useState(10);
    // loader du meeting à voir et télécharger
    const [loading, setLoading] = useState(false);
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    // Création des cellules têtes du tableau
    // Les ids des cellules doivent correspondre aux noms des champs DTO, sauf l'action
    const headCells: HeadCellDto<RelationIndicatorsBillsDto, keyof RelationIndicatorsBillsDto>[] = [
        { id: 'city', label: 'Collectivité', sort: false, width: 20 },
        { id: 'theoricNumberOfBills', label: 'Nombre théorique de factures', sort: false, width: 20 },
        { id: 'facturationMonth', label: 'Mois de facturation', sort: false, width: 20 },
        { id: 'billsValidationMonth', label: 'Mois de la validation des factures', sort: false, width: 20 },
    ];
    //Méthode au changement de la page
    const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    //Méthode au changement d'items par page
    const handleChangeItemsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setItemsPerPage(Number.parseInt(event.target.value, 10));
        setPage(0);
    };

    /**
     * Demandes par communes à l'ouverture de la page, puis à chauqe changement de page ou de itemsParPage
     */
    useEffect(() => {
        if (props.mandate) {
            setLoading(true);
            getRelationBillsIndicators(props.mandate.id, page, itemsPerPage)
                .then(async result => {
                    if (result) {
                        setBillsIndicators(result);
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des documents');
                    showAxiosMessageError(error, showMessage);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [page, itemsPerPage, props.mandate, showMessage]);

    //Mise en place du tableau reunion passées
    const showTableRequests = () => {
        if (billsIndicators === undefined) {
            // Affichage du skeleton le temps de recevoir les données
            return <Skeleton variant="rectangular" height={250}></Skeleton>;
        }
        if (billsIndicators.totalItems === 0) {
            // Si pas de données on envoit no data
            return <NoData title={'Information : '} content={'Aucune information à venir'} />;
        } else {
            return (
                // Table stylisée
                <StyledTable
                    data={billsIndicators.items}
                    searching={loading}
                    headCells={headCells}
                    totalItems={billsIndicators.totalItems}
                    page={page}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeItemsPerPage}
                    itemsPerPage={itemsPerPage}
                ></StyledTable>
            );
        }
    };

    //Retourne la vue
    return (
        <Grid container className={'relation-request-content'} spacing={2}>
            {/* Affichage du tableau des communes */}
            <Grid item xs={12}>
                <Typography className="relationUi__sectionTitle" variant={'h5'}>
                    Détail par collectivité
                </Typography>
            </Grid>
            <Grid item xs={12}>
                {/* Tableau des communes */}
                {showTableRequests()}
            </Grid>
        </Grid>
    );
}
